import React from 'react';
import { PropertyGroup } from './PropertyGroup';
import { isLayoutContentField } from '../constants';

/**
 * Required field property component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RequiredProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  const isLayoutField = isLayoutContentField(field.type);
  const excludeRequired = ['tabs', 'hidden'].includes(field.type);
  if (isLayoutField || excludeRequired) {
    return null;
  }
  return /*#__PURE__*/_jsx(PropertyGroup, {
    children: /*#__PURE__*/_jsxs("label", {
      className: "checkbox-label",
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        checked: field.required || false,
        onChange: e => updateField(selectedField, {
          required: e.target.checked
        })
      }), "Required field"]
    })
  });
};